import { http } from 'http';

export default {
  createNewCampaign: params => http.post('/webh/campaigns/createpublish', params),
  editCampaign: params => http.post('/campaigns', params),
  createClientsCampaign: (campaignId, params) =>
    http.post(`/campaigns/${campaignId}/clients`, params),
  cloneCampaign: params => http.post('/webh/campaigns/clone', params),
  unsubscribe: id => http.post(`/campaigns/unsubscribe/${id}`),
  unpublishCampaign: ({ campaignId, marketplaceId }) => {
    const endpoint = marketplaceId
      ? `/campaigns/unpublish/${campaignId}?marketPlaceId=${marketplaceId}`
      : `/campaigns/unpublish/${campaignId}`;
    return http.post(endpoint);
  },
  createMarketplace: params => http.post('/webh/publishtomarketplace', params),
  publishOmega: params => http.post('/webh/omega/campaign', params),
  vehiclesLiberation: params => http.post(`/webh/campaigns/vehicleLiberation`, params),
  campaignsCleanOfferFamily: idOffer =>
    http.post(`/webh/campaigns/limpiarFamiliaOferta?idOferta=${idOffer}`),
  orderCampaign: (campaingns, partnerId) => http.post(`/catalog/order/${partnerId}`, campaingns)
};
